
<div *ngIf="(formgroup != null) && !nullValue" [formGroup]="formgroup" class="form-check">
 <input  #cb
  class="form-check-input"
  type="checkbox" 
  [id]="ie.InterfaceElementID"
  [formControlName]="ie.InterfaceElementID"
  [checked]="ie.Values!=null && ie.Values.length>0 ?ie.Values[0].Value == 'true': false" 
  (change)="fetchIEUserAction(ie.Attributes.OnChangeUAID, cb.checked, null, null, null, formgroup, null)">
</div>

<div *ngIf="(formgroup == null) && !nullValue" class="form-check">
  <input #cb 
  class="form-check-input" 
  type="checkbox" 
  [checked]="ie.Values[0].Value == 'true'" 
  (change)="fetchIEUserAction(ie.Attributes.OnChangeUAID, cb.checked, null, null, null, formgroup, null)">
  <label *ngIf="label" class="form-check-label" [attr.for]="ie.InterfaceElementID">{{ie.PreLabel.DisplayName}}</label>
</div>
  
<div *ngIf="nullValue && RTKeyShowNullable" [formGroup]="formgroup" class="form-check">
  <input  #cb 
    class="form-check-input"
    type="checkbox"
    [id]="ie.InterfaceElementID + '_null'"
    [formControlName]="ie.InterfaceElementID + '_null'"
    [checked]="ie.Values[0].nil == true" 
    (change)="fetchIEUserAction(ie.Attributes.OnChangeUAID, cb.checked, null, null, null, formgroup, null)">
    <label class="form-check-label" [for]="ie.InterfaceElementID + '_null'" >null</label>
</div>
